import { apiClient } from '@/services/client/ApiClient.js';

export default {
  getAll() {
    return apiClient.get('/maps', { useCache: true });
  },

  getByPhase(phaseId = 1) {
    return apiClient.get('/maps/by-phase/' + phaseId);
  },

  getByIds(ids) {
    return apiClient.get('/maps/by-ids/' + JSON.stringify(ids));
  },

  getSubLayersByParentLayerID(layerId) {
    return apiClient.get('/maps/by-parent-id/' + layerId);
  },

  getLayersForIndividualPins() {
    return apiClient.get('/maps/for-individual-pins/');
  },

  toggleActiveLayer(layerId) {
    let locstorage = window.localStorage;
    let activeLayers = JSON.parse(locstorage.getItem('activeLayers2'));

    if (activeLayers) {
      // activeLayers are initialized
      var index = activeLayers.indexOf(layerId);

      if (index == -1) {
        // Layer is not active => add it to array of activeLayer
        activeLayers.push(layerId);
      } else if (index > -1) {
        // Layer is active => remove it from array of activeLayers
        activeLayers.splice(index, 1);
      }
    } else {
      // activeLayers are NOT initialized
      activeLayers = [];
      activeLayers.push(layerId);
    }
    locstorage.setItem('activeLayers2', JSON.stringify(activeLayers));
  },

  /**
   * @param {number} layerId
   */
  deactivateLayer(layerId) {
    let locstorage = window.localStorage;
    let activeLayers = JSON.parse(locstorage.getItem('activeLayers2'));

    if (activeLayers) {
      // activeLayers are initialized
      var index = activeLayers.indexOf(layerId);

      if (index > -1) {
        // Layer is active => remove it from array of activeLayers
        activeLayers.splice(index, 1);
      }
    } else {
      // activeLayers are NOT initialized
      activeLayers = [];
    }
    locstorage.setItem('activeLayers2', JSON.stringify(activeLayers));
  },

  getActiveLayers() {
    return new Promise((resolve) => {
      resolve(JSON.parse(window.localStorage.getItem('activeLayers2')));
    });
  },

  getLayersWithCanAddIndividualPin(phaseId) {
    return this.getByPhaseId(phaseId).then((response) => {
      if (response.data) {
        return response.data.filter(
          (layer) => layer.canAddIndividualPin === true
        );
      }
    });
  }
};
